import Vue from "vue";
import Vuetify from "vuetify/lib";
import es from "vuetify/es5/locale/es";

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: "mdiSvg"
  },
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        primary: "#00BCD4", // cyan
        secondary: "#4DD0E1", // cyan lighten-2
        accent: "#0097A7", // cyan darken-2
        error: "#FF7043", // deep-orange lighten-1
        info: "#29B6F6", // light-blue lighten-1
        success: "#8BC34A", // light-green
        warning: "#FFC107" // amber
      }
    }
  },
  lang: {
    locales: { es },
    current: "es"
  }
});
